var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 32,
      height: 32,
      viewBox: "0 0 32 32",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.3334 27.1274H16.0001V18.8608C16.0001 18.1234 16.5961 17.5274 17.3334 17.5274H20.3201L20.9134 15.3941H17.3334C16.5961 15.3941 16.0001 14.7981 16.0001 14.0608V10.4608C16.0001 9.06344 17.1961 7.92744 18.6668 7.92744H21.3334V5.79411H18.6668C15.7254 5.79411 13.3334 7.88744 13.3334 10.4608V14.0608C13.3334 14.7981 12.7374 15.3941 12.0001 15.3941H9.33343V17.5274H12.0001C12.7374 17.5274 13.3334 18.1234 13.3334 18.8608V27.1274ZM17.3334 29.7941H12.0001C11.2627 29.7941 10.6667 29.1981 10.6667 28.4608V20.1941H8.00008C7.26275 20.1941 6.66675 19.5981 6.66675 18.8608V14.0608C6.66675 13.3234 7.26275 12.7274 8.00008 12.7274H10.6667V10.4608C10.6667 6.41811 14.2547 3.12744 18.6667 3.12744H22.6667C23.4041 3.12744 24.0001 3.72344 24.0001 4.46077V9.26077C24.0001 9.99677 23.4041 10.5941 22.6667 10.5941H18.6667V12.7274H22.6667C23.0827 12.7274 23.4761 12.9234 23.7281 13.2541C23.9801 13.5861 24.0627 14.0168 23.9521 14.4181L22.6187 19.2168C22.4587 19.7941 21.9321 20.1941 21.3334 20.1941H18.6667V28.4608C18.6667 29.1981 18.0707 29.7941 17.3334 29.7941Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgFacebook, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/facebook.b3afe4c2.svg";
export { ForwardRef as ReactComponent };